define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Boolean"
], function(declare,_,BooleanRen) {
	
	return declare(BooleanRen, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: if on level above Question then display number of flagged questions below
			var value = this._getValue(ctx, h);
			if (value == null) {
				value = ctx.getNodeAttributeValue("NumFlagged", true);
				if (value == null) {
					// SubQuestion level
					return false;
				}
				
				refNode.innerHTML = value;
				return true;
			}
			
			return this.inherited(arguments);
		}
	});
});